import Address from '@/rest/address';
import LoginForm from '@/interface/api/LoginForm';
import Rest from './rest';
import AccountResp from '@/interface/api/AccountResp';
import CommentResp from '@/interface/api/CommentResp';
import CommentLoadForm from '@/interface/api/CommentLoadForm';
import LoginResultResp from '@/interface/api/LoginResultResp';
import PublicPageInUploadForm from '@/interface/api/PublicPageInUploadForm';
import AccountSettingResp from '@/interface/api/AccountSettingResp';
import FormSettingPassword from '@/interface/FormSettingPassword';
import ProfileResp from '@/interface/api/ProfileResp';
import Pageable from '@/interface/api/common/Pageable';
import StatisticsForm from '@/interface/api/StatisticsForm';
import common from '@/common';
import PasswordResetForm from '@/interface/api/PasswordResetForm';
import PasswordSaveForm from '@/interface/api/PasswordSaveForm';
import FormSignUp from '@/interface/api/FormSignUp';
import ActivateForm from '@/interface/api/ActivateForm';
import CommentWriteForm from '@/interface/api/CommentWriteForm';
import ContactForm from '@/interface/api/ContactForm';
import ProfileForm from '@/interface/api/ProfileForm';
import ProgrammingCourseForm from '@/interface/api/ProgrammingCourseForm';
import UploadSettingsForm from '@/interface/api/UploadSettingsForm';

// APIを叩く処理を集めたクラス
export class RestAccess {
  private address: Address;
  private rest: Rest;

  constructor(host: string) {
    this.address = new Address(host);
    this.rest = new Rest();
  }

  //ログイン情報を取得する
  getAccount = (): Promise<AccountResp> => {
    return this.rest.get(this.address.accountPath()).then((res: Response) => {
      return res.json();
    }).catch((e)=>{
      if (process.env.VUE_APP_MODE === "development")console.log("アカウント取得でエラーが発生しました。サーバーが起動していないか、アカウントCookieを変更したら直るかも知れません", e);
      throw e;
    });
  }

  // GoodCountをゲット
  getPublicPageGoodCount = (userName: string, publicPageTitle: string): Promise<number> => {
    return this.rest.get(this.address.publicPageGoodPath(userName, publicPageTitle)).then((res: Response) => {
      return res.json();
    })
  }

  // //プロジェクトのリストをゲット、created atでソート
  // getProjectList = (page: number): Promise<PublicPageResp[]> => {
  //   const params = { page: page, size: 10, sort: "createdAt,desc" } as any;
  //   const qs = new URLSearchParams(params);
  //   return this.rest.get(this.address.projectListPath(), qs.toString()).then((res: Response) => { return res.json().then(arrJson => toProjectList(arrJson)) });
  // }

  // //タイムラインのリストをゲット
  // getTimeline = (page: number): Promise<PublicPageResp[]> => {
  //   const params = { page: page, size: 10 } as any;
  //   const qs = new URLSearchParams(params);
  //   return this.rest.get(this.address.timelinePath(), qs.toString()).then((res: Response) => { return res.json().then(arrJson => toProjectList(arrJson)) });
  // }

  // // いいねランキングリスト
  // getLikesRankingList = (page: number): Promise<PublicPageResp[]> => {
  //   const params = { page: page, size: 10, sort: "goodCount , desc" } as any;
  //   const qs = new URLSearchParams(params);
  //   return this.rest.get(this.address.projectListPath(), qs.toString()).then((res: Response) => { return res.json().then(arrJson => toProjectList(arrJson)) });
  // }

  // // 人気リスト
  // getPopularList = (page: number): Promise<PublicPageResp[]> => {
  //   const params = { page: page, size: 10, sort: "goodCount , desc" } as any;
  //   const qs = new URLSearchParams(params);
  //   return this.rest.get(this.address.popularListPath(), qs.toString()).then((res: Response) => { return res.json().then(arrJson => toProjectList(arrJson)) });
  // }

  // ログイン
  postLogin = (login: LoginForm): Promise<LoginResultResp> => {
    const form = new FormData();
    form.append("name", login.name);//WebSecurityConfigと名称を合わせる
    form.append("password", login.password);//WebSecurityConfigと名称を合わせる
    if(login.rememberMe) form.append("rememberMe", "1");//SpringSessionRememberMeServicesと名称を合わせる

    return this.rest.postForm(this.address.loginPath(), form).then((res: Response) => {
      return res.json();
    });
  }

  // ログアウト
  postLogout = (): Promise<any> => {
    return this.rest.post(this.address.logoutPath()).then(() => { });
  }

  // 公開ページ情報をプロジェクト単位で取得する
  getMyProject = (projectId: string): Promise<Response> => {
    return this.rest.get(this.address.getProjectPath(projectId));
  }

  getPublicPage = (userName: string, publicPageTitle: string): Promise<Response> => {
    return this.rest.get(this.address.userPublicPagePath(userName, publicPageTitle)).then((res: Response) => { return res });
  }

  countUpVisited = (publicPageId:number) => {
    return this.rest.patch(this.address.publicPageViewing(publicPageId)).then((res: Response) => { return res });
  }

  // いいね する
  putLikesPublicPage = (userName: string, publicPageTitle: string): Promise<any> => {
    return this.rest.put(this.address.publicPageLiksPath(userName, publicPageTitle)).then((res: Response) => { return res.json() });
  }

  // good する
  putGoodPublicPage = (userName: string, publicPageTitle: string): Promise<any> => {
    return this.rest.put(this.address.publicPageGoodPath(userName, publicPageTitle)).then((res: Response) => { return res.json() });
  }

  // コメントする
  postCommentPublicPage = (body: CommentWriteForm): Promise<any> => {
    // POST
    return this.rest.post(this.address.commentPostPath(), undefined, body).then((res: Response) => {
      if (res.ok) {
        return res.json()
      }
      throw res;
    });
  }

  // コメントをリストで取得する
  getCommentsPublicPage = (projectId:number, publicPageId:number,  condition:String|null, lastComment:CommentResp|null, limit:number): Promise<CommentResp[]> => {
    //ややこしいがPostとする。URLにconditionを入れると文字数制限が短いため。
    return this.rest.post(this.address.commentGetPath(), undefined, {
      projectId: projectId,
      publicPageId: publicPageId, 
      condition, 
      lastSceneTime: lastComment?.sceneMilliSecond,
      limit
    } as CommentLoadForm).then((res: Response) => { return res.json() });
  }

  // コメントにナイスする いまは動かない
  putNiceComment = (userName: string, publicPageTitle: string, commentId: any): Promise<any> => {
    return this.rest.put(this.address.commentNicePath(userName, publicPageTitle, commentId), undefined).then((res: Response) => { return res.json() });
  }

  // いいね を外す
  deleteLikesPublicPage = (userName: string, publicPageTitle: string): Promise<any> => {
    return this.rest.delete(this.address.publicPageLiksPath(userName, publicPageTitle), undefined).then((res: Response) => { return res.json() });
  }

  //フォローする
  followUser = (userName: any): Promise<any> => {
    return this.rest.put(this.address.followPath(userName), undefined).then((res: Response) => { return res });
  }

  //フォローを外す
  unFollowUser = (userName: any) => {
    return this.rest.delete(this.address.followPath(userName), undefined).then((res: Response) => { return res });
  }

  // フォロー関係のリストをget
  getFollowList = (userName: string) => {
    return this.rest.get(this.address.followPath(userName))
  }
  
  //しばらく不要だったら消す（2021/10/24)
  // getNewProject = (): Promise<Response> => {
  //   return this.rest.get(this.address.newProject()).then((res: Response) => {
  //     return res;
  //   });
  // }

  savePupblicPage = (projectId:number|undefined, publicPage: PublicPageInUploadForm): Promise<Response> => {
    return this.rest.post(this.address.savePublicPagePath(projectId), undefined, publicPage);
  }

  deletePupblicPage = (projectId:number, publicPageId: number): Promise<Response> => {
    return this.rest.delete(this.address.deletePublicPagePath(projectId, publicPageId), undefined);
  }

  saveUploadSettings = (uploadSettings: UploadSettingsForm): Promise<Response> => {
    return this.rest.post(this.address.saveUploadSettingPath(), undefined, uploadSettings);
  }

  createNewProject = (): Promise<Response> => {
    return this.rest.post(this.address.createNewProject(), undefined);
  }

  checkPublicPageTitle = (publicPageId: number | null | undefined, titleURL: string) => {
    return this.rest.get(this.address.checkPublicPageTitlePath(publicPageId, titleURL), undefined);
  }
  
  getMyProjectList = (pageable: Pageable) => {
    return this.rest.get(this.address.accountMyProject(), this.createPagerQeury(pageable));
  }

  // アカウント設定を取得 今はemailのみ
  getAccountSetting = (): Promise<Response> => {
    return this.rest.get(this.address.accountSetting()).then((res: Response) => {
      return res;
    })
  }

  // アカウントをアップデート
  saveAccountSetting = (settingDto: AccountSettingResp): Promise<AccountSettingResp> => {
    return this.rest.patch(this.address.accountSetting(), undefined, settingDto).then((res: Response) => {
      return res.json();
    })
  }

  // パスワードをアップデート
  saveSettingPassword = (formPassword: FormSettingPassword): Promise<any> => {
    return this.rest.putForm(this.address.accountSettingPassword(), this.createFormData(formPassword)).then((res: Response) => {
      return res;
    })
  }

  // プロフィール設定を取得
  getAccountProfile = (): Promise<ProfileResp> => {
    return this.rest.get(this.address.accountSettingProfile()).then((res: Response) => {
      if(process.env.VUE_APP_MODE === "development"){
        if(res.status === 404){
          console.log("プロフィールが見つかりませんでした。もしかしてテスト用のuser_profileテーブルを作成していないユーザでは？")
        }
      }
      return res.json();
    })
  }

  // dataをFormDataにする。
  createFormData(obj: any): FormData {
    // eslint-disable-next-line prefer-const
    let formData = new FormData();
    Object.keys(obj).forEach((key: string) => {
      // nullをapeendすると文字列になるので、除外する。
      if (obj[key] != null) {
        formData.append(key, obj[key]);
      }
    });
    return formData;
  }

  // プロフィールを更新
  saveAccountProfile = (formObj: ProfileForm): Promise<Response> => {
    return this.rest.patchFormData(this.address.accountSettingProfile(), this.createFormData(formObj))
  }

  // プロフィール情報を取得
  getUserData = (userName: string): Promise<Response> => {
    return this.rest.get(this.address.userProfile(userName))
  }

  createSearchQuery(searchWord: string | null | (string | null)[], pageable: Pageable): string {
    const query = new URLSearchParams();
    let str = "";
    if (Array.isArray(searchWord)) {
      str = searchWord.join(" ");
    } else if(searchWord){
      str = searchWord;
    }
    query.append("q", str);
    query.append("size", pageable.size + "");
    query.append("page", pageable.page + "");
    if (process.env.VUE_APP_MODE === "development")console.log("検索クエリ :", query.toString());
    return query.toString();
  }

  private createPagerQeury = (pageable: Pageable) => {
    const query = new URLSearchParams();
    query.append("size", pageable.size + "");
    query.append("page", pageable.page + "");
    return query.toString();
  }

  // 検索する プロジェクト
  searchPublicPage = (searchWord: string | null | any[], pageable: Pageable): Promise<Response> => {
    return this.rest.get(this.address.searchPublicPagePath(), this.createSearchQuery(searchWord, pageable))
  }

  // 検索する ユーザー
  searchUser = (searchWord: string | null | any[], pageable: Pageable): Promise<Response> => {
    return this.rest.get(this.address.searchUserPath(), this.createSearchQuery(searchWord, pageable))
  }

  // メインページ用のデータを取得
  getUpdatedPublicPageList = (pageable: Pageable): Promise<Response> => {
    return this.rest.get(this.address.timelineUpdated(), this.createPagerQeury(pageable))
  }
  // getAllProjectList = (): Promise<Response> => {
  //   return this.rest.get(this.address.timelineAll(), undefined)
  // }

  // バッジデータを取得
  public getAccountBadge = (): Promise<Response> => {
    return this.rest.get(this.address.accountSettingBadge(), undefined)
  }

  //  バッジデータを更新
  public updateBadge(badge: any): Promise<Response> {
    return this.rest.patch(this.address.accountSettingBadge(), undefined, badge);
  }

  // ユーザー行動をpost
  public postStatistics(timing: string, data: any = null): void {
    //他の通信の邪魔しないよう気持ち遅らせる
    setTimeout(()=>{
      const a = {timing, data: (!data || common.isString(data)) ? data : JSON.stringify(data)} as StatisticsForm
      this.rest.post(this.address.postStatistics(), undefined, a);
    }, 800)
  }

  // stripe sessionを作成
  public createStripeSession(priceId: string): Promise<Response> {
    return this.rest.post(this.address.createSession(), undefined, { priceId });
  }

  public passwordEmailConfirm(email: string | null): Promise<Response> {
    return this.rest.post(this.address.passwordEmailConfirm(), undefined, { email } as PasswordResetForm);
  }
  public passwordTokenConfirm(token: any): Promise<Response> {
    return this.rest.get(this.address.passwordTokenConfirm(), "token=" + token);
  }
  public passwordSave(token: any, password: string | null): Promise<Response> {
    return this.rest.post(this.address.passwordSave(), "token=" + token, { password } as PasswordSaveForm);
  }
  
  public contactToConsult(email: string | null): Promise<Response> {
    return this.rest.post(this.address.contactToConsult(), undefined, { email } as ContactForm);
  }
  public contactToEntryProgramming(email: string, text: string): Promise<Response> {
    return this.rest.post(this.address.contactToEntryProgramming(), undefined, { email, text } as ProgrammingCourseForm);
  }
  

  public signupEmail(email: string | null): Promise<Response> {
    return this.rest.post(this.address.signupEmail(), undefined, { email } as FormSignUp);
  }
  public signupTokenConfirm(token: any): Promise<Response> {
    return this.rest.get(this.address.signupTokenConfirm(), "token=" + token);
  }
  public activate(token: any, userName: string | null, password: string | null): Promise<Response> {
    return this.rest.post(this.address.activate(), "token=" + token, { userName, password } as ActivateForm);
  }



  // 公開バッジデータを取得
  public getPublicBadge = (userName:string): Promise<Response> => {
    return this.rest.get(this.address.publicBadge(userName), undefined)
  }
  public getAllComments = (userName:string, pageable: Pageable): Promise<Response> => {
    return this.rest.get(this.address.getAllComments(userName), this.createPagerQeury(pageable))
  }


  // // フォルダをアップロードする
  // uploadFolder = (body:any) :Promise<any>=> {
  //   return this.rest.postImage(this.address.uploaderPath(), undefined, body).then((res:Response) => {return res.json()});
  // }

  // // ファイルやフォルダを消去する
  // deleteItems = (path:any) :Promise<any>=> {
  //   const params = new URLSearchParams();
  //   params.append("path", path);
  //   console.log("params ", params.toString());

  //   return this.rest.delete2(
  //     this.address.uploaderPath(), params.toString())
  //     .then((res:Response) => {return res.json()});
  // }
}

export default new RestAccess(process.env.VUE_APP_MELON + "/api/");

